const initModel = {
    terms: false,
    terms_accepted: false,
    login:  { loggedin: false },
    upload: { success: '', error: '', errorModal: false, files: {} , filesArr: [], fileNames: [],
                dguList: [], addedDgu: [], addedDguFull: [],
                wkt: [], geoFysList: [], addedGeoFysProject: [], tab: 'metadata',
                selectedKeyword: [], selectedMethod: [], selectedCenter: [],
                selectedLaws: '', selectedPurpose: '', selectedMunicipality: '',
                addedModelLink: [], selectArea: 'tabKeyword', drawType: 'Ingen' },
    state: 'frontPage',
    kommuneno: '',
    rapportid: '',
    anytext: '',
    selectedKeyword: [],
    error: null,
    success: null,
    request: {},
//    queryResult: [],
    noSearch: true,
    offset: 0,
    call: false,
    detail : {
        queryResult: { links: [] }
    },
    constLists: {
        searchKeywords: [],
        searchMethods: [],
        searchCentres: [],
        searchLaws: [],
        searchPurpose: [],
        searchMunicipality: [],
    }
};

export default initModel;